import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { ILine } from "../lineModel";

export const getAllLine = createAsyncThunk("Line/FindAllLine", async () => {
  try {
    const response = await axiosApiInstance.post(
      `${API_URL}/Line/FindAllLine`,
      {
        Line: "",
      }
    );
    return response.data?.Data;
  } catch (error: any) {
    // ErrorToast(error?.response?.data?.Details || "Something went wrong");
    console.error("Error Fetching Line:", error);
    return Promise.reject({
      message: error?.response?.data?.Details || "Something went wrong",
    });
  }
});

export const getAllActiveLine = createAsyncThunk(
  "Line/FindAllActiveLine",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Line/FindAllActiveLine`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Line:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createLine = createAsyncThunk(
  "Line/InsertLine",
  async (LineData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Line/InsertLine`,
        LineData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Line:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateLine = createAsyncThunk(
  "Line/UpdateLine",
  async (LineData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Line/UpdateLine`,
        LineData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Line:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getLineByID = createAsyncThunk(
  "Line/FindByIDLine",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Line/FindByIDLine`,
        { line_guid: ID }
      );
      const result = response.data?.Data as any;
      return {
        line_guid: result.line_guid,
        line_name: result.line_name,
        description: result.description,
        isactive: result.isactive === true ? 1 : 2,
      } as ILine;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Line:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const lineActiveInactive = createAsyncThunk(
  "Line/ActiveInActiveLine",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Line/ActiveInActiveLine`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Line:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteLine = createAsyncThunk(
  "Line/DeleteLine",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Line/DeleteLine`,
        { line_guid: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Line:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
